<template>
  <div>
    <div class="flexible-activity" />
    <v-dialog
      v-model="dialog"
      content-class="dialog-flexible"
      persistent
      overlay-color="darktext"
    >
      <v-card>
        <v-card-title>
          {{ $t('continueLogin') }}
        </v-card-title>
        <v-card-text>
          {{ $t('loginContinueDescription') }}
        </v-card-text>
        <div
          v-for="idp in idps"
          :key="idp.name"
          class="text-right"
        >
          <v-card-actions 
            v-if="idp.enabled && idp.configured_properly"
            class="flex-column flex-sm-column px-6 py-0 flex-md-row align-end"
          >
            <v-btn
              data-testid="saml-submit-button"
              type="submit"
              width="100%"
              large
              block
              class="rounded-xxl text-none greytext--text px-4"
              @click="samlLoginUser(idp.name)"
            ><v-icon class="mr-2" color="greytext">mdi-cloud-outline</v-icon>
              {{ idp.button_text }}
            </v-btn>
          </v-card-actions>
        </div>
        <v-card-actions class="flex-column  flex-sm-column px-6 flex-md-row align-end">
          <v-spacer />
          <v-btn
            ref="cancel"
            data-testid="cancel-button"
            color="darktext"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 mb-2 mb-md-0"
            @click="redirectRegister()"
          >
            {{ $t('createAccountTitle') }}
          </v-btn>
          <v-btn
            data-testid="submit-button"
            color="accent"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4"
            @click="redirectLogin()"
          >
            {{ $t('login') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { samlLoginUser } from '../api/userApi'

export default {
  props: {

  },
  data () {
      return {
        dialog: true,
        activityId: this.$route.params.id,
        space: window.location.host.split('.')[0],
        pageId:this.$route.params.pageId,
        idps: localStorage.space ? JSON.parse(localStorage.space).idps : [],
      }
  },
  computed: {

  },
  created() {
      if (this.idps && this.idps.length > 0) {
        this.idps.forEach(idp => {
            if (idp.enabled && idp.configured_properly && idp.direct_redirect) {
                this.samlLoginUser(idp.name)
            }
        })
      }
  },
  methods: {
    redirectLogin(){
      if(this.pageId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/page/" + this.pageId
      }
      else {
           window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId;
      }
    },
    redirectRegister() {
      if(this.pageId) {
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId +"/page/" + this.pageId
      }
      else {
           window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId;
      }
    },
    async samlLoginUser(idpName){
      try {
        let redirect = ''
        if (this.space) {
          redirect = process.env.VUE_APP_PROTOCOL + "://" + this.space + "." + process.env.VUE_APP_DOMAIN + "/saml-login"
        }

        const response = await samlLoginUser(idpName, redirect, this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId)
        if (response.status == 200) {
            window.open(response.data.url, "_self");
        }
      } catch (e) {
      if(e.response){
        if(e.response.status == 403){
            this.$router.push('/forbidden')
          }
        }
      }
    },
  },
}
</script>
<style>
.flexible-activity{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vw;
    background: url(../assets/large-activity.png);
    z-index: 9;
}
@media only screen and (max-width:768px){
  .flexible-activity {
    background: url(../assets/tablet-activity.png);
    height: 100vh;
  }
}
@media only screen and (max-width:767px){
  .flexible-activity {
    background: url(../assets/mobile-activity.png);
    height: 100vh;
  }
}
.v-dialog__content--active .dialog-flexible.v-dialog--active{
  width: auto;
  max-width: min-content;
}
.v-dialog__content--active .dialog-flexible.v-dialog--active .v-card__text{
  max-width: fit-content;
  width: auto;
}
</style>